import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import defaultAvatar from "../../assets/imgs/avatar.png";

interface Props {
  imgSrc?: string | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Avatar',
  props: {
    imgSrc: null
  },
  setup(__props: any) {

const props = __props as {
  imgSrc?: string | undefined;
}


const src = computed(() => {
  if (isError.value) {
    return defaultAvatar;
  }
  return props.imgSrc || defaultAvatar;
});
const isError = ref(false);
function handleError() {
  isError.value = true;
}

return { __sfc: true,props, src, isError, handleError }
}

})